'use strict';


import * as map_styles from './map-style';

export let initMap = ()=>{
    sunshineMap6km();
    sunshineMap3km();
    cairnsMap6km();
    cairnsMap3km();
}

var lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      scale: 1,
      strokeWeight: 5,
    };

var map1, map2, map3, map4;
var offset1, offset2, offset3, offset4;

export let reloadMap = ()=>{
    console.log("start resizing");
    google.maps.event.trigger(map1, 'resize');
    map1.setCenter(offset1);
    google.maps.event.trigger(map2, 'resize');
    map2.setCenter(offset2);
    google.maps.event.trigger(map3, 'resize');
    map3.setCenter(offset3);
    google.maps.event.trigger(map4, 'resize');
    map4.setCenter(offset4);
}

function sunshineMap6km(){
    var map;
    var startpoint = {lat: -26.669229, lng:153.107143};
    var endpoint = {lat: -26.667705,  lng: 153.106295};
    var mapOffset = {lat:-26.679729, lng: 153.120183};
    offset1 = mapOffset;

    map = new google.maps.Map(document.getElementById('google-map-sunshine-10k'), {
        center: mapOffset,
        scrollwheel: false,
        zoom: 14,
        styles: map_styles.jsonstyle
    });
    map1 = map;

    var directionsDisplay = new google.maps.DirectionsRenderer({
        map: map,
        draggable: false,
        markerOptions: { visible: false },
        polylineOptions: {
            strokeColor: '#EC018A',
            strokeOpacity: 0,
            clickable: false,
            icons:[{
                icon: lineSymbol,
                offset: '0',
                repeat: '1px'
            }]
        },
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        preserveViewport: true
    });

    // Set destination, origin and travel mode.
    var request = {
        destination: endpoint,
        origin: startpoint,
        travelMode: 'WALKING',
        waypoints: [{location:{lat:-26.684794, lng: 153.128203}, stopover:false}]
    };

    // Pass the directions request to the directions service.
    var directionsService = new google.maps.DirectionsService();
    directionsService.route(request, function(response, status) {
        if (status == 'OK') {
        // Display the route on the map.
        directionsDisplay.setDirections(response);
        }

    });
}

function sunshineMap3km(){
    var map;
    var startpoint = {lat: -26.669229, lng:153.107143};
    var endpoint = {lat: -26.667705,  lng: 153.106295};
    var mapOffset = {lat:-26.672541, lng:153.111464};
    offset2 = mapOffset;

    map = new google.maps.Map(document.getElementById('google-map-sunshine-5k'), {
      center: mapOffset,
      scrollwheel: false,
      zoom: 14,
      styles: map_styles.jsonstyle
  });
  map2 = map;

  var directionsDisplay = new google.maps.DirectionsRenderer({
      map: map,
      draggable: false,
      markerOptions: { visible: false },
      polylineOptions: {
          strokeColor: '#EC018A',
          strokeOpacity: 0,
          clickable: false,
          icons:[{
              icon: lineSymbol,
              offset: '0',
              repeat: '1px'
          }]
      },
      disableDefaultUI: true,
      disableDoubleClickZoom: true,
      preserveViewport: true
  });

  // Set destination, origin and travel mode.
  var request = {
      destination: endpoint,
      origin: startpoint,
      travelMode: 'WALKING',
      waypoints: [{location:{lat:-26.677565, lng:153.117043}, stopover:false}]
  };

  // Pass the directions request to the directions service.
  var directionsService = new google.maps.DirectionsService();
  directionsService.route(request, function(response, status) {
      if (status == 'OK') {
      // Display the route on the map.
      directionsDisplay.setDirections(response);
      }

  });
}


function cairnsMap6km(){
    var map;
    var startpoint = {lat: -16.919009, lng: 145.778145};
    var endpoint = {lat: -16.901805, lng: 145.759477};
    var mapOffset = {lat:-16.910541,lng:145.767124};
    offset3 = mapOffset;

    map = new google.maps.Map(document.getElementById('google-map-cairns-10k'), {
        center: mapOffset,
        scrollwheel: false,
        zoom: 14,
        styles: map_styles.jsonstyle
    });
    map3 = map;
    console.log("Create map")
    var directionsDisplay = new google.maps.DirectionsRenderer({
        map: map,
        draggable: false,
        markerOptions: { visible: false },
        polylineOptions: {
            strokeColor: '#EC018A',
            strokeOpacity: 0,
            clickable: false,
            icons:[{
                icon: lineSymbol,
                offset: '0',
                repeat: '1px'
            }]
        },
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        preserveViewport: true
    });
    console.log("Display direction")

    // Set destination, origin and travel mode.
    var request = {
        destination: endpoint,
        origin: startpoint,
        travelMode: 'WALKING',
        waypoints: [{location:{lat:-16.908929, lng: 145.766472}, stopover:false}]
    };
    console.log("Set destination")

    // Pass the directions request to the directions service.
    var directionsService = new google.maps.DirectionsService();
    directionsService.route(request, function(response, status) {
        if (status == 'OK') {
        // Display the route on the map.
        directionsDisplay.setDirections(response);
        }

    });
    console.log("Pass directions")
}

function cairnsMap3km(){
    var map;
    var startpoint = {lat: -16.919009, lng: 145.778145};
    var endpoint = {lat:-16.910541,lng:145.767124};
    var mapOffset = {lat:-16.916778,lng:145.774630};
    offset4 = mapOffset;

    map = new google.maps.Map(document.getElementById('google-map-cairns-5k'), {
        center: mapOffset,
        scrollwheel: false,
        zoom: 15,
        styles: map_styles.jsonstyle
    });
    map4 = map;

    var directionsDisplay = new google.maps.DirectionsRenderer({
        map: map,
        draggable: false,
        markerOptions: { visible: false },
        polylineOptions: {
            strokeColor: '#EC018A',
            strokeOpacity: 0,
            clickable: false,
            icons:[{
                icon: lineSymbol,
                offset: '0',
                repeat: '1px'
            }]
        },
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        preserveViewport: true
    });

    // Set destination, origin and travel mode.
    var request = {
        destination: endpoint,
        origin: startpoint,
        travelMode: 'WALKING',
        waypoints: [{location:{lat:-16.916778,lng:145.774630}, stopover:false}]
    };

    // Pass the directions request to the directions service.
    var directionsService = new google.maps.DirectionsService();
    directionsService.route(request, function(response, status) {
        if (status == 'OK') {
        // Display the route on the map.
        directionsDisplay.setDirections(response);
        }

    });
}



// WEBPACK FOOTER //
// ./src/js/google-maps.js